// @flow
import { useContext } from 'react';
import { UserContext } from '@src/contexts/UserContext';

import { EARLY_ACCESS_USERS_LIST } from './constants';

const useDoesUserHaveEarlyAccess = () => {
  const { userEmail = '' } = useContext(UserContext);
  return true || EARLY_ACCESS_USERS_LIST.includes(userEmail);
};

export default useDoesUserHaveEarlyAccess;
